module.exports = __webpack_public_path__ + "media/images/pic/brodno/polygon_news_smaller_bg-9f879309a693ea4c1a1641c2ece7b95b.png";